export default {
  "command.open": "Open browser",
  "command.reload": "Reload browser page",
  "command.inspect": "Select an element in the browser page",
  "command.address": "Focus browser address",
  "command.close": "Close browser tab",
  "tab.title": "Browser",
  "tab.new": "New tab",
  "address.label": "Browser address",
  "address.search": "Search or enter a URL",
  "address.suggestions": "Suggestions",
  "refused.web": "Only web pages can open here.",
  "refused.workspace": "Only web pages and files inside this session's workspace can open here.",
  "refused.credentials": "Addresses with a user name or password can't open here.",
  inspect: "Select an element to comment on",
  "inspect.active": "Click an element in the page to comment on it. Press Escape to cancel.",
  "inspect.pageShortcut": "While the page has focus",
  "action.stop": "Stop",
  replaced: "Browser control moved to another desktop window.",
  unsupported: "This desktop app does not support the browser pane.",
  suspended: "Browser suspended. Interact with this session to reconnect.",
  "home.title": "Open a page",
  "home.description": "Preview your app, read docs, or browse the web.",
  "home.recent": "Recent",
  "failed.title": "URL can't be reached",
  "failed.description": "Check the URL and your connection, then try again.",
  "action.reload": "Reload",
  "site.info": "Site information",
  "site.secure": "Connection is secure",
  "site.insecure": "Connection is not secure",
  "site.insecure.description": "Don't enter passwords or other private information on this page.",
  "site.local": "Local server",
  "site.local.description": "Local addresses open on the machine that runs the OpenCode server.",
  "site.file": "Workspace file",
  "site.file.description": "Only files inside this session's workspace can open here.",
  "site.network": "Pages load through the network of {{server}}.",
  "site.cookies": "Cookies and site data",
  "site.cookies.count.one": "{{count}} cookie in use",
  "site.cookies.count.other": "{{count}} cookies in use",
  "site.cookies.clear": "Clear",
  "site.permissions": "Permissions are blocked",
  "site.permissions.description": "Camera, microphone, location, and notifications don't work in this browser.",
  "site.agent": "The agent can use this page",
  "site.agent.description": "It can read the page, run scripts, and fill in forms.",
  "page.add": "Add page to session",
  "page.placeholder": "Add context about this page",
  "external.open": "Open in system browser",
  "external.unavailable": "This address only works on the server's machine.",
  options: "Browser options",
  "zoom.in": "Zoom in",
  "zoom.out": "Zoom out",
  "zoom.reset": "Reset zoom",
  "zoom.percent": "{{percent}}%",
  "link.copy": "Copy link",
  "history.clear": "Clear browsing history",
}
